import React, { memo } from "react";
import BaseNode from "../CdpBaseNode";
import { Titles } from "../Titles";

export default ({ id, data, selected, isConnectable }) => {
  return (
    <BaseNode
      id={id}
      data={data}
      valueType={"currency"}
      valid={true}
      type={data.type}
      selected={selected}
      title={Titles.CustomerTotalSpend}
      isConnectable={isConnectable}
    />
  );
};
